import { FlapNotificationType } from 'Webapp/enums';
import useLinkSection from 'Webapp/shared/app/components/notifications/notification-text-click-strategies/use-link-section';
export default useLinkSection(FlapNotificationType.MILESTONE);
